import * as React from 'react';
export const rampSvg = React.forwardRef(function rampSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5FF78',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M28 25.666v.093H14.93v-.096a20.39 20.39 0 0 0 4.356-3.347h5.368L28 25.666ZM24.76 8.313 21.448 5h-.096s.056 6.174-5.507 11.79C10.401 22.286 4 22.297 4 22.297v.096l3.376 3.37s6.307.064 11.88-5.509c5.57-5.57 5.504-11.94 5.504-11.94Z',
      fill: '#292827',
    }),
  );
});
rampSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var ramp = {
  category: 'brand',
  colorable: false,
  name: 'ramp',
  svg: rampSvg,
};
